<template>
  <div class="view box grow" style="overflow-y: auto">
    <page-headers
      :header="'Launchpad'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-integration"
      class="box"
    >
    </page-headers>
    <div class="full-width">
      <span class="material-icons float-right cursor-pointer" @click="gotoIntegrationList">close</span>
    </div>
    <div class="workflow-view">
      <aws-integration-workflow v-if="integrationType === 'aws'" />
      <gcp-integration-workflow v-if="integrationType === 'gcp'"/>
      <azure-integration-workflow v-if="integrationType === 'azure'"/>
      <kubernetes-integration-workflow v-else-if="integrationType === 'kubernetes'"/>
      <pan-integration-workflow v-else-if="integrationType === 'pan'" @close-page="gotoIntegrationList"/>
      <carbon-black-integration-workflow v-else-if="integrationType === 'carbonblack'" @close-page="gotoIntegrationList"/>
      <snyk-integration-workflow v-else-if="integrationType === 'snyk'" @close-page="gotoIntegrationList"/>
      <guard-duty-integration-workflow v-else-if="integrationType === 'guardduty'" @close-page="gotoIntegrationList"/>
      <trend-micro-integration-workflow v-else-if="integrationType === 'trendmicro'" @close-page="gotoIntegrationList"/>
      <aws-lb-integration-workflow v-else-if="integrationType === 'awslb'" @close-page="gotoIntegrationList"/>
      <rds-integration-workflow v-else-if="integrationType === 'rds'" @close-page="gotoIntegrationList"/>
      <cloud-trail-integration-workflow v-else-if="integrationType === 'cloudtrail'" @close-page="gotoIntegrationList"/>
      <jira-setting v-else-if="integrationType === 'jira'"/>
      <devo-integration-workflow v-else-if="integrationType === 'devo'" @close-page="gotoIntegrationList"/>
      <wef-integration-workflow v-else-if="integrationType === 'wef'" @close-page="gotoIntegrationList"/>
      <historical-cloud-trail-data-integration-workflow v-else-if="integrationType === 'cloudtrail_history'" @close-page="gotoIntegrationList"/>
      <azure-log-integration-workflow v-else-if="integrationType === 'azurelog'" @close-page="gotoIntegrationList"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import {
  AwsIntegrationWorkflow,
  CarbonBlackIntegrationWorkflow,
  PanIntegrationWorkflow,
  SnykIntegrationWorkflow,
  KubernetesIntegrationWorkflow,
  GuardDutyIntegrationWorkflow,
  TrendMicroIntegrationWorkflow,
  AwsLbIntegrationWorkflow,
  RdsIntegrationWorkflow,
  GcpIntegrationWorkflow,
  AzureIntegrationWorkflow,
  CloudTrailIntegrationWorkflow,
  DevoIntegrationWorkflow,
  WefIntegrationWorkflow,
  HistoricalCloudTrailDataIntegrationWorkflow,
  AzureLogIntegrationWorkflow
} from '@/components/form/integrations'
import {JiraSetting} from '@/views/admin'

export default {
  name: 'IntegrationWorkflow',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data() {
    return {
      integrationType: this.$route.params.integrationType,
      breadcrumbs: [
        {title: 'Setup'},
        {title: 'Launchpad', to: '/integrations'},
        // { title: 'Configure', to: '/integrations/configuration' },
        {title: ''}
      ],
      prevRoute: {}
    }
  },
  methods: {
    gotoIntegrationList() {
      this.$router.push(this.prevRoute.path !== '/' ? {
        name: this.prevRoute.name,
        query: this.prevRoute.query,
        params: this.prevRoute.params
      } : {
        path: this.prevRoute.path
      })
    }
  },
  created() {
    this.activeView = this.$route.path.split('/').reverse()[0]
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    prevRoute(newVal, oldVal) {
      this.breadcrumbs[2].title = this.integrationType
    }
  },
  components: {
    PageHeaders,
    AwsIntegrationWorkflow,
    CarbonBlackIntegrationWorkflow,
    PanIntegrationWorkflow,
    SnykIntegrationWorkflow,
    KubernetesIntegrationWorkflow,
    GuardDutyIntegrationWorkflow,
    TrendMicroIntegrationWorkflow,
    AwsLbIntegrationWorkflow,
    RdsIntegrationWorkflow,
    GcpIntegrationWorkflow,
    AzureIntegrationWorkflow,
    CloudTrailIntegrationWorkflow,
    JiraSetting,
    DevoIntegrationWorkflow,
    WefIntegrationWorkflow,
    HistoricalCloudTrailDataIntegrationWorkflow,
    AzureLogIntegrationWorkflow
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.workflow-view {
  height: calc(100% - 175px);
  margin: 5% 5% 0px 5%;
}
</style>



// WEBPACK FOOTER //
// src/views/integrations/IntegrationWorkflow.vue